App.SmRadioGroupComponent = Em.Component.extend
  classNames: [ 'sm-radio-group' ]

  value: null
  onChange: null

